import { render } from "./TrustAccounts.vue?vue&type=template&id=e8394e02&scoped=true"
import script from "./TrustAccounts.vue?vue&type=script&lang=js"
export * from "./TrustAccounts.vue?vue&type=script&lang=js"

import "./TrustAccounts.vue?vue&type=style&index=0&id=e8394e02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8394e02"]])

export default __exports__